var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDizzy = function SvgDizzy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.417 12.89a2.53 2.53 0 0 0-2.528-2.529 2.53 2.53 0 0 0-2.528 2.528 4.307 4.307 0 0 0 8.611 0 6.085 6.085 0 0 0-6.083-6.083 6.085 6.085 0 0 0-6.083 6.083 7.864 7.864 0 0 0 7.861 7.861 7.864 7.864 0 0 0 7.861-7.86c0-5.322-4.318-9.64-9.639-9.64-5.328 0-9.639 4.318-9.639 9.64a.75.75 0 0 0 1.5 0 8.14 8.14 0 0 1 8.139-8.14 8.14 8.14 0 0 1 8.139 8.14 6.364 6.364 0 0 1-6.361 6.36 6.363 6.363 0 0 1-6.361-6.36 4.584 4.584 0 0 1 4.583-4.584 4.584 4.584 0 0 1 4.583 4.584 2.806 2.806 0 0 1-5.611 0 1.029 1.029 0 0 1 2.056 0 .75.75 0 0 0 1.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgDizzy;